export default class AmAssingmentsService {
  constructor(accessManagementAPI, gettext) {
    'ngInject';
    this.amAPI = accessManagementAPI;
    this.commands = {
      ASSIGN: 'assign',
      UNASSIGN: 'unassign'
    };
    this.assignmentStatus = {
      dispatched: {
        label: gettext('Pending'),
        iClass: 'material-icons pending color-low-priority',
        color: 'color-low-priority'
      },
      received: {
        label: gettext('Pending'),
        iClass: 'material-icons pending color-low-priority',
        color: 'color-low-priority'
      },
      complete: {
        label: gettext('Successful'),
        iClass: 'material-icons success success-green',
        color: 'success-green'
      },
      failed: {
        label: gettext('Failed'),
        iClass: 'material-icons failed color-high-priority',
        color: 'color-high-priority'
      }
    };
  }

  perform(assetsIds = [], operatorsIds = [], assingmentcommand) {
    return this.amAPI.performAssignments(assetsIds, operatorsIds, assingmentcommand);
  }
  assign(assetsIds = [], operatorsIds = []) {
    return this.amAPI.performAssignments(assetsIds, operatorsIds, this.commands.ASSIGN);
  }
  unassign(assetsIds = [], operatorsIds = []) {
    return this.amAPI.performAssignments(assetsIds, operatorsIds, this.commands.UNASSIGN);
  }
}
